import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { evAddPaymentInstrument } from 'events/account';

import {
  fetchPaymentInfo,
  updateBillingAddress,
  updateCardNumber,
  updateExpirationMonth,
  updateExpirationYear,
  updateFullName,
  updatePaymentInfo
} from 'actions/account/payment';
import { fetchShippingInfo } from 'actions/account/shipping';
import { firePixelServer } from 'actions/pixelServer';
import { reverseReturnUrlLookup } from 'helpers/MyAccountUtils';
import AccountHeader from 'containers/account/AccountHeader';
import Breadcrumb from 'components/account/Breadcrumb';
import BackNav from 'components/account/BackNav';
import PaymentForm from 'components/account/PaymentForm';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import { PageLoader } from 'components/Loader';
import { titaniteView, track } from 'apis/amethyst';
import styles from 'styles/containers/account/addPayment.scss';

const items = [
  { name: 'Payment Information', url: '/payments' },
  { name: 'Add New Payment' }
];

export class AddPayment extends Component {
  componentDidMount() {
    titaniteView();

    const { firePixelServer, shipping: { addresses } } = this.props;
    if (!addresses) {
      this.fetchData();
    }
    firePixelServer('my-account', {}, 'payment-add');
  }

  fetchData() {
    const { fetchShippingInfo } = this.props;
    fetchShippingInfo(null, '/payments/new');
  }

  handleUpdatePaymentInfo = (card, addressId, returnTo) => {
    const { updatePaymentInfo } = this.props;
    Promise.resolve(updatePaymentInfo(card, addressId, returnTo)).then(response => {
      if (response?.paymentInstrumentId) {
        const { paymentInstrumentId, isPrimarySuccess } = response;
        track(evAddPaymentInstrument, { valid: true, paymentInstrumentId, isPrimarySuccess });
      }
    });
  };

  render() {
    const {
      location: { search },
      shipping: { addresses, isLoading },
      payment,
      updateFullName,
      updateCardNumber,
      updateBillingAddress,
      updateExpirationMonth,
      updateExpirationYear
    } = this.props;

    if (!addresses || isLoading) {
      return <PageLoader centered={true}/>;
    }

    const { returnTo } = queryString.parse(search);
    const isValidReturnUrl = Boolean(reverseReturnUrlLookup(returnTo));

    return (
      <SiteAwareMetadata>
        <div className={styles.addPayment}>
          <Breadcrumb items={items}/>
          <BackNav to={isValidReturnUrl ? returnTo : '/payments'}>
            {isValidReturnUrl ? reverseReturnUrlLookup(returnTo) : 'Payment Information'}
          </BackNav>
          <AccountHeader title="Add New Payment" showCustomerEmail={false}/>
          <PaymentForm
            payment={payment}
            addresses={addresses}
            returnTo={returnTo}
            onUpdateFullName={updateFullName}
            onUpdateCardNumber={updateCardNumber}
            onUpdateBillingAddress={updateBillingAddress}
            onUpdateExpirationMonth={updateExpirationMonth}
            onUpdateExpirationYear={updateExpirationYear}
            onUpdatePaymentInfo={this.handleUpdatePaymentInfo} />
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = state => ({
  payment: state.payment,
  shipping: state.shipping
});

export default connect(mapStateToProps, {
  fetchShippingInfo,
  fetchPaymentInfo,
  firePixelServer,
  updatePaymentInfo,
  updateFullName,
  updateCardNumber,
  updateExpirationMonth,
  updateExpirationYear,
  updateBillingAddress
})(AddPayment);
